module.exports = new __parcel__URL__("Druideskill_26.660935e2.png").toString();